import { render, staticRenderFns } from "./BrandCardComponent.vue?vue&type=template&id=73e98d7e"
import script from "./BrandCardComponent.vue?vue&type=script&lang=js"
export * from "./BrandCardComponent.vue?vue&type=script&lang=js"
import style0 from "./BrandCardComponent.vue?vue&type=style&index=0&id=73e98d7e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports